module.exports = __webpack_public_path__ + "img/sCallH.101bc81a.svg";